module.exports = __webpack_public_path__ + "media/images/sp/stores/tachikawa/tachikawa_sns_04-96bda232164afbbb8f23d22a38deb082.jpg";